export default __webpack_public_path__ + "static/hero-banner-720-20aa0633c1e4904e116b448cbd102791.mp4";